import { AthenaEvent } from '@/common/hooks/useAthena/athenaEvents';

interface useAthenaProps {
  pushEvent: (event: AthenaEvent) => void;
}

const isAthenaReady = (): boolean => {
  return window?.athena !== undefined && window.athenaUserinfo !== undefined;
};

const ensureAthenaQueue = (): boolean => {
  if (typeof window === 'undefined') {
    // while in SSR there's no window
    return false;
  }

  if (window.athenaQueue === undefined) {
    window.athenaQueue = [];
  }
  return true;
};

export const useAthena = (): useAthenaProps => {
  ensureAthenaQueue();

  const pushToQueue = (event: AthenaEvent): void => {
    window.athenaQueue.push(event);
  };

  const pushEvent = (event: AthenaEvent): void => {
    if (typeof window === 'undefined') {
      // while in SSR there's no window
      return;
    }

    if (isAthenaReady()) {
      window.athena(event);
    } else {
      pushToQueue(event);
    }
  };

  ensureAthenaQueue();
  return {
    pushEvent,
  };
};
